import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { UserRound } from 'lucide-react';
import { cn } from '../../../helpers/cn';
import Jazzicon from './jazzicon.mjs';
/** The shared deterministic identicon, without address-book subscriptions. */
export function AddressIconView({ address, size, className, saved = false, }) {
    const ref = useRef(null);
    const renderSize = size ?? 24;
    const badgeSize = Math.max(9, Math.round(renderSize * 0.5));
    const badgeOffset = Math.max(1, Math.round(renderSize * 0.08));
    useEffect(() => {
        const container = ref.current;
        if (!container)
            return;
        container.replaceChildren();
        if (!address)
            return;
        const iconElement = Jazzicon(renderSize, parseInt(address.slice(2, 10), 16));
        if (iconElement) {
            iconElement.style.display = 'block';
            iconElement.style.width = '100%';
            iconElement.style.height = '100%';
            iconElement.style.borderRadius = '0';
            container.appendChild(iconElement);
        }
    }, [address, renderSize]);
    return (_jsxs("div", { "data-address-icon": true, "aria-hidden": "true", className: cn('relative rounded-md', className), style: size ? { width: size, height: size } : undefined, children: [_jsx("div", { className: "absolute inset-0 overflow-hidden rounded-[inherit]", children: _jsx("div", { className: "absolute inset-0", ref: ref }) }), saved && (_jsx("div", { className: "absolute flex items-center justify-center rounded-full bg-secondary-600 border-2 border-secondary-800 text-primary-text", style: {
                    width: badgeSize,
                    height: badgeSize,
                    right: -badgeOffset,
                    bottom: -badgeOffset,
                }, children: _jsx(UserRound, { style: { width: '62%', height: '62%' }, strokeWidth: 2.5 }) }))] }));
}
